<si-info-page
  icon="element-warning-filled"
  iconColor="status-danger"
  titleText="PSS®E Copilot "
  copyText="You don't have access to this application. Please contact administrator to request access to application."
  instructions=""
  [link]="{ title: 'Go back', link: '/' }"
/>